import React from "react";
import { FaLinkedin, FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";

const Footer = () => (
  <footer>
    {/* <p class="about">
      <strong color="gray">About | <u>Reel</u></strong>
    </p>
  */}

    <p class="role">
      {/* <u>Motion Design</u>, Compositing, Web/Game Dev.  */}
       </p>
      <p class="bio">
      I am a motion designer, compositing artist and occasional coder. Currently interested in Interactive, VR/AR/XR, with a general focus on 3D work. 
      Experience creating engaging content for various projects; including animation, games, print and film.  
      {/* Hoping to help make some interesting projects as soon as possible.  */}
      {/* find a healthy work life balance within the near future. */}

      {/* I am a motion designer and compositor; interested in Interactive, VR/AR/XR, Illustration, and primarily 3D work.  */}
      {/* I have experience creating compelling content for various projects such as animation, compositing, and illustration.  */}
      {/* My goal is to specialize and one day achieve a healthy work life balance. :) */}
      </p>

      <div className="social-media">


      <ul>
      <li><MdEmail />shemshortall@gmail.com</li>
      <li><FaLinkedin />linkedin.com/in/shemshortall</li>
      <li><FaInstagram/>instagram.com/shemshortall</li>
    </ul>

    </div>
  </footer>
);

export default Footer;